import {
  ApplicationConfig,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  inject,
} from '@angular/core';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { JwtInterceptor } from '../helper/jwtinterceptor';
import { Commonservice } from '../services/commonservice';
import { AppPreferencesService } from '../services/app-preferences';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideClientHydration(),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    provideAppInitializer(() => {
      const commonSvc = inject(Commonservice);
      const preferencesSvc = inject(AppPreferencesService);
      preferencesSvc.initializePreferences();
      return commonSvc.initializeAuthState();
    }),
  ]
};
